import styles from "./view_assembly.module.css";
import "github-markdown-css/github-markdown.css"
import 
{
  Button,
  Col,
  Input,
  InputNumber,
  notification,
  Row,
  Select,
  Spin,
  Tabs,
  Upload,
  Image,
  UploadProps,
  Modal,
  Table,
  Space,
  Tooltip,
  Collapse,
  FormInstance,
  Result,
  Descriptions,
  Dropdown,
  Typography,
  UploadFile,
} from "antd";
import { Form } from "antd";
import Title from "antd/lib/typography/Title";
import React, {CSSProperties, useContext, useEffect, useState} from "react";
import { Link, useParams } from "react-router-dom";
import DependencyCriteria, {EditCategoryRuleConfig } from "../components/dependency_criteria";
import { MetadataFieldList } from "../components/metadata_field";
import { ConfiguratorContext } from "../context";
import NotFoundPage from "./not_found";
import {
  DeleteOutlined,
  DownloadOutlined,
  InboxOutlined,
  InfoCircleTwoTone,
  WarningFilled,
  PlusOutlined,
  QuestionCircleOutlined,
  MoreOutlined,
  UploadOutlined
} from "@ant-design/icons";
import AssemblySelector from "../components/assembly_selector";
import { Assembly, AssemblyChangeType, AssemblyHistory, AssemblyMetadata, AssemblyOperation, AssemblyTags, BaseModel, Category, CategoryMetadata,
  DependencyRule, MISSING_IMAGE, Operation, OPERATION_TYPE, PAGINATION_MAX_PAGE_SIZE, Permission, PricingConfig } from "../api/models";
import {useAsyncState} from "../hook/useAsyncState";
import {AssemblyRequest} from "../api";
import {StringParam, useQueryParam} from "use-query-params";
import AssemblyCostHistory from "../components/AssemblyCostHistory";
import BMButton from "../components/BMButton";
import Utils from "../util/util";
import {useIntl} from "react-intl";
import dayjs from "dayjs";
import {ValidateFields} from "rc-field-form/lib/interface";
import { ColumnType } from "antd/es/table";
import { ValidateErrorEntity } from "rc-field-form/lib/interface";
import ModelMultipleSelector from "../components/ModelMultipleSelector";
import useModels from "../swr/useModels";
import useAssemblyDocuments from "../swr/useAssemblyDocuments";
import useQuoteList from "../swr/useQuoteList";
import useDealers from "../swr/useDealers";
import DealerMultipleSelector from "../components/DealerMultipleSelector";
import NewAssemblyModal from "../components/new_assembly_modal";
import BMReadOnly from "../components/BMReadOnly";
import CategorySelector from "../components/category_selector";
import useAssemblyInfoList from "../swr/useAssemblyInfoList";
import QuoteEndCustomerSelector from "../components/quote_endCustomer_selector";
import CustomerTagSelector from "../components/customer_tag_selector";
import useCustomers from "../swr/useCustomers";
import useAssembly from "../swr/useAssembly";
import Markdown from "react-markdown";
import remarkGfm from 'remark-gfm'
import useBaseCategories from "../swr/useBaseCategories";
import useCategory from "../swr/useCategory";
import Paragraph from "antd/lib/typography/Paragraph";

export interface NewAssemblyOperation {
  id?: number
  operationId?: string
  hours?:number
  group?:string
}

enum UPLOADING_STATUS {
  INIT = "init",
  ERROR = "error",
  DONE = "done",
  UPLOADING = "uploading"
}

export interface AssemblyFormValues {
  id: number
  metadata: AssemblyMetadataFormValues[] | undefined
  restrictions: number[] | undefined
  operations: AssemblyOperation[] | undefined
  dealerExclusives: string[] | undefined
  customerExclusives: string[] | undefined
  customerTagExclusives: string[] | undefined
  label: string | undefined
  dependencyRules?: string | undefined
  standardMaterialCost?: number | undefined
  labelWizard?: string | undefined
  descriptionWizard?: string | undefined
  assemblyDependencies: number[] | undefined
  modelIds?: number[] | undefined
  notes?: string | undefined
  replacementAssemblyId:number | undefined
  tags?:AssemblyTags[] | undefined
}
export interface AssemblyMetadataFormValues {
  id?:number
  categoryMetadata:CategoryMetadata
  valueText?:string
  valueBool?: boolean
  valueNumeric?: number
  valueDecimal?: number
}

type OperationMapType = {
  [key: string]: OPERATION_TYPE | undefined;
};

const gotoQuoteList = (assemblyId:number | undefined) => {
  if ( !assemblyId ) return;

  window.open(`/quotes?assemblies=${assemblyId}`, "_blank");
}

export const buildFormMetadata = (assembly:Assembly, category:Category) : AssemblyMetadata[] =>  {

  const assemblyMetadata:AssemblyMetadataFormValues[] = assembly?.metadata?.filter( md => category?.metadata.some( cm => cm.id === md.categoryMetadata.id  )) || [];

  const categoryMetadata:AssemblyMetadataFormValues[] = category?.metadata.filter( cm => !assemblyMetadata.some( md  => cm.id === md.categoryMetadata.id  ) ) 
    .map( cm => ({categoryMetadata:cm}) ) || [];

  return [
  ...assemblyMetadata,
  ...categoryMetadata
  ];
}

const ViewAssembly = () => {
  const params = useParams<any>();
  const [tabKeyParam, setTabKey] = useQueryParam<string | undefined | null >("tab", StringParam);
  const configurator = useContext(ConfiguratorContext);
  const [notFound, setNotFound] = useState<boolean>(false);
  const [dependencyRules, setDependencyRules] = useState<Array<EditCategoryRuleConfig>>([]);
  const [operations, operationsAsync] = useAsyncState<Operation[]>();
  const [latestPricing, setLatestPricing] = useState<PricingConfig>();
  const [assemblyHistory, setAssemblyHistory] = useState<AssemblyHistory[]>([]);
  const [_groupOptions, setGroupOptions] = useState<{}>({});
  const [initialValues, setInitialValues] = useState<AssemblyFormValues>();
  const [form] = Form.useForm();
  const canWrite = configurator.hasPermission(Permission.ENGINEERING_WRITE);
  const intl = useIntl();
  const [operationMapping, setOperationMapping] = useState<OperationMapType>({});
  const [validationAlert, setValidationAlert] = useState<string[]>([]);
  //preserve is required here to avoid infinite re-renders.  not sure why
  const tags = Form.useWatch("tags", {form, preserve: true});
  const categoryIdFormValue = Form.useWatch( "categoryId", form);
  const obsoleted = tags?.includes(AssemblyTags.Obsolete)

  const assemblyAsync = useAssembly({assemblyId:params.id});
  const assembly = assemblyAsync.data;

  const models = useModels({
    inactive: true,
    deleted: true,
    size: PAGINATION_MAX_PAGE_SIZE,
  })

  const replacementAssemblyLst = useAssemblyInfoList({
    filterOptions:{
      categoryId: assembly?.categoryId,
    },
    pageSize:PAGINATION_MAX_PAGE_SIZE
  })
  const categoryLst = useBaseCategories();

  const assemblyCategoryAsync = useCategory({id:assembly?.categoryId});
  const assemblyCategory = assemblyCategoryAsync.data;

  const selectedCategoryAsync = useCategory({id:categoryIdFormValue});
  const selectedCategory = selectedCategoryAsync.data;

  useEffect(() => {

    if( assembly && assemblyCategory ) {
      Promise.all([
        loadLatestPricing(),
        loadOperations(),
        loadHistory(params.id),
      ])
          .then(() => {

            if (assembly.dependencyRules) {
              setDependencyRules(JSON.parse(assembly.dependencyRules).map((dr: EditCategoryRuleConfig) => ({
                ...dr,
                uuid: crypto.randomUUID()
              })));
            }

            const metadata =  (assemblyCategory)
                ? buildFormMetadata(assembly, assemblyCategory)
                : [];

            setInitialValues({
              ...assembly,
              assemblyDependencies: assembly.assemblyDependencies.map(d => d.id),
              metadata,
            });
          });
    }
  }, [assembly, assemblyCategory?.id]);

  useEffect(() => {
    if ( !!selectedCategory?.id && !!assembly?.categoryId && selectedCategory?.id !== assembly?.categoryId ) {
      //todo - there is a bug when switching back to the original category
      showCategoryChangeWarning();
    }

  }, [selectedCategory?.id]);

  useEffect(() => {

    form.resetFields();
  }, [initialValues]);

  const isLoading = assemblyAsync.isLoading || categoryLst.isLoading || operationsAsync.isLoading();
  const isLoadingFail = !assembly || !!categoryLst.error || operationsAsync.isFail();
  const isImported = ( assembly && assembly?.imported );

  const loadLatestPricing = async () => {
    const pricing = (await configurator.api.getLatestPricing()).data;
    setLatestPricing(pricing);
  };


  const loadOperations = () => {
    operationsAsync.setLoading()
    return configurator.api.fetchAssemblyOperations()
      .then( resp => {
        operationsAsync.setDone(resp.data?.sort((a, b) => a.operationId.localeCompare(b.operationId) ));

        const newMapping = resp.data.reduce((acc, op) => {
          acc[op.operationId] = op.defaultType;
          return acc;
        }, {});

        setOperationMapping(newMapping)
      },
        (e) =>  {
            const errorMsg = intl.formatMessage({ id: e.message });
            notification.error( { message: "Failed load operations. " + errorMsg });
            operationsAsync.setFail(e.message);
          });
  }

  const assemblyStatistics = useQuoteList({
    filter: {
      filterAssemblies: [ params.id ]
    },
    current: 0,
    pageSize: 1,
  })
  const quoteCnt = assemblyStatistics.data?.totalElements;

  const dateDescendingSort = (a:AssemblyHistory, b:AssemblyHistory) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();

  const loadHistory = async (id: number) => {
    try {
      const resp = await configurator.api.getAssemblyHistory(id);
      setAssemblyHistory(resp.data.sort(dateDescendingSort));
    }
    catch (e: any) {
      notification.error( { message: "Failed to load assembly history. " + e });
    }
  }

  const onSubmitForm = async (changeReason: string) => {
    try {
      const values = await form.validateFields() as AssemblyFormValues;

      const saveDependencyRules = dependencyRules.filter( dr => dr.rules.length || dr.whenRules.length );

      //required for json patch and category changes
      const removeMetadata = assembly?.metadata
          .reduce((acc, md) => {
            acc[ md.categoryMetadata.id ] = null;
            return acc;
          }, {})

      const addMetadata = values.metadata
          ?.map(md => ({
            ...md,
            categoryMetadataId: md.categoryMetadata.id,
            //remove junk
            updatedAt:undefined, createdAt: undefined, categoryMetadata: undefined, name: undefined
          }))
          .reduce((acc, md) => {
            acc[ md.categoryMetadataId ] = md;
            return acc;
          }, {})

      const metadata = {
        ...removeMetadata,
        ...addMetadata,
      }

      const req: AssemblyRequest = {
        ...values,
        modelIds: values.modelIds?.sort(),
        metadata,
        dependencyRules: JSON.stringify(saveDependencyRules),
        dependencies: values.assemblyDependencies,
        changeReason,
      };

      const saved = await saveAssembly( values.id, req );
      if ( saved ) {
        assemblyAsync.mutate(saved);

        setValidationAlert([]);

        notification.success({ message:"Assembly successfully updated."});
      }
    } catch (e:any) {
      notification.error({message: "Please fix validation errors." });
    }
  };

  const saveAssembly = async (assemblyId:number, req:AssemblyRequest) : Promise<Assembly | undefined> => {

    try {
      const resp = await configurator.api.updateAssembly( assemblyId, req);
      return resp.data;
    } catch (e: any) {
      const errorMsg = intl.formatMessage({ id: e.message || e.response?.data.message });
      const msg = "Failed to save assembly. " + errorMsg;
      notification.error( { message: msg });
    }

    return;
  }

  const onAddNewDependency = () => {
    if ( !assembly ) return;

    const newRules = dependencyRules.concat( {
      uuid: crypto.randomUUID(),
      category: assembly.category.id,
      rules: [],
      whenRules: [],
    });
    setDependencyRules(newRules);
  };

  const NOT_FOUND = -1;
  const onUpdateCriteria = (cri:DependencyRule[], uuid:string) => {

    const idx = dependencyRules.findIndex( dr => dr.uuid === uuid );
    if ( idx === NOT_FOUND ) return;

    dependencyRules[idx] = {
      ...dependencyRules[ idx ],
      rules: cri,
    };
    setDependencyRules([...dependencyRules]);
  };

  const handleMoveToPending = async ()=> {
    const saved = await moveToPending();
    if (saved) {
      assemblyAsync.mutate(saved);
    }
  }

  async function moveToPending() {
    if ( !assembly ) return;

    try {
      const resp = await configurator.api.resetAssemblyPending(assembly.id);
      return resp.data;
    } catch (e: any) {
      const errorMsg = intl.formatMessage({ id: e.message || e.response?.data.message });
      const msg = "Failed to move back to pending. " + errorMsg;
      notification.error( { message: msg });
    }
  }

  const handleChangeCategory = () => {
    const metadata = selectedCategory?.metadata.map( cmd => ({categoryMetadata: cmd}) )

    form.setFieldValue('metadata', metadata );
  }

  const handleCancelChangeCategory = () => {
    form.setFieldValue( 'categoryId', assembly?.categoryId );
  }

  const showCategoryChangeWarning = () => {
          Modal.confirm({
            icon:<></>,
            content: <Result 
              status={"warning"}
              title={"Category has changed!"}
              subTitle={"This will affect existing quotes and clear all metadata."}
            />,
            onOk: handleChangeCategory,
            onCancel: handleCancelChangeCategory,
          });

  }

  if ( notFound ) {
    return <div className="site-layout-background"><NotFoundPage /></div>
  }

  const isCurrentOrSelected = (ao:AssemblyOperation|NewAssemblyOperation|undefined, o:Operation) => o.current || ao?.operationId === o.operationId;

  interface UploadImageResponse {
    status:string | undefined, 
    response?:{ 
      thumbnailUrl:string
      fullSizeUrl:string
    } 
  }
  const UploadImage = ( props:{
    style?: CSSProperties
    assemblyId: number | undefined
    thumbnailImageUrl: string | undefined
    onChange?: () => void
  } ) => {
    const { assemblyId, thumbnailImageUrl } = props;
    const [uploadFile, setUploadFile] = useState<UploadImageResponse>({status: UPLOADING_STATUS.INIT});

    useEffect(()=> {
      if( uploadFile.status == UPLOADING_STATUS.DONE ) {
        notification.success( {message: "Upload complete."} );
        props.onChange?.();
      }
      else if( uploadFile.status == UPLOADING_STATUS.ERROR ) {
        notification.error(  {message: "There was an error uploading the image."});
      }

    }, [ uploadFile.status] )


    const isUploading = UPLOADING_STATUS.UPLOADING == uploadFile.status;
    const uploadImageUrl = assemblyId ? configurator.api.baseUrl + "/v1/assembly/" + encodeURIComponent(assemblyId) + "/image" : "";
    const onUploadChange: UploadProps['onChange'] = ({file}) => {
      setUploadFile( {status: file.status, response: file.response } );
    };

    return <Upload.Dragger
      name="image"
      action={uploadImageUrl}
      withCredentials={true}
      showUploadList={false}
      accept=".jpg,.jpeg,.png,.gif,.tiff"
      style={props.style}
      maxCount={1}
      onChange={onUploadChange}
      disabled={!canWrite}
    >
      <Spin spinning={isUploading}>
        {thumbnailImageUrl 
          ? <Image
            src={ uploadFile.response?.thumbnailUrl || thumbnailImageUrl || MISSING_IMAGE }
            fallback={MISSING_IMAGE}
            style={{paddingBottom: ".5rem"}}
            width={200}
            preview={false}
          />
          :<p className="ant-upload-drag-icon">
            <InboxOutlined  />
          </p>

        }
      </Spin>
      <p className="ant-upload-text" style={{fontSize:"small"}}>{!canWrite ? "You need permission to upload image" : "Click or drag file to upload image"}</p>
    </Upload.Dragger>

  }

  const DocumentsTabPane = () => {
    const assemblyId = assembly?.id;
    const documentsAsync = useAssemblyDocuments({assemblyId});
    const documents = documentsAsync.data;
    const [pendingFiles, setPendingFiles] = useState<UploadFile[]>([]);

    const uploadedFiles = documents?.map( d => ({
      uid: String(d.id),
      name: d.filename,
      type: d.contentType,
      status: 'done',
      url: d.url,
    }) ) as UploadFile[] | undefined;

    const fileList = [ ...(uploadedFiles || []), ...pendingFiles ];

    const handleDownload = (file:UploadFile) => {
      const doc = documents?.find( d => String(d.id) === file.uid );
      if ( doc?.url ) {
        configurator.api.downloadFile( doc.url, { mimeType: doc.contentType, filename: doc.filename } );
      }
    };

    const handleRemove = async (file:UploadFile) : Promise<boolean> => {
      const doc = documents?.find( d => String(d.id) === file.uid );
      if ( !assemblyId || !doc ) return false;
      try {
        await configurator.api.deleteAssemblyDocument( assemblyId, doc.id );
        notification.success( {message: "Document removed."} );
        documentsAsync.mutate();
      }
      catch(e:any) {
        notification.error( {message: "Failed to remove document."} );
      }
      return false;
    };

    const onUploadChange: UploadProps['onChange'] = ({file, fileList: changedList}) => {
      if ( file.status === UPLOADING_STATUS.DONE ) {
        setPendingFiles([]);
        notification.success( {message: "Upload complete."} );
        documentsAsync.mutate();
      }
      else if ( file.status === UPLOADING_STATUS.ERROR ) {
        setPendingFiles([]);
        notification.error( {message: "There was an error uploading the document."} );
      }
      else {
        const uploadedUids = new Set( uploadedFiles?.map( f => f.uid ) );
        setPendingFiles( changedList.filter( f => !uploadedUids.has(f.uid) ) );
      }
    };

    const uploadDocumentUrl = assemblyId ? configurator.api.getUploadAssemblyDocumentUrl(assemblyId) : "";

    return <>
      <Typography.Paragraph type="secondary" style={{maxWidth: "40rem"}}>
        Documents attached here are internal-only and are listed in the Documents section of any quote or order that includes this assembly.
      </Typography.Paragraph>
      <Upload
        name="document"
        action={uploadDocumentUrl}
        withCredentials={true}
        fileList={fileList}
        onChange={onUploadChange}
        onDownload={handleDownload}
        onRemove={handleRemove}
        showUploadList={{
          showDownloadIcon: true,
          downloadIcon: <DownloadOutlined />,
          showPreviewIcon: false,
          showRemoveIcon: canWrite,
        }}
      >
        {canWrite &&
          <Button icon={<UploadOutlined />}>Upload Document</Button>}
      </Upload>
      {!documents?.length && !canWrite &&
        <Typography.Text type="secondary">No documents.</Typography.Text>}
    </>;
  }

  const CostHistoryTabPane = () => {

    var laborHours = assembly?.operations.map(o => o.hours).reduce((v, acc) => acc += v, 0) || 0;
    var laborHourlyCost = latestPricing?.laborHourlyCost || 0;
    var laborCost = laborHours * laborHourlyCost;

    return <>
      <Form
        form={form}
        name="costs"
        initialValues={initialValues}
        labelAlign="right"
        disabled={!!getDisabledUpdateMsg()}
      >
        <Title level={4}>Assembly Cost</Title>
        <Row gutter={16}>
          <Col>
            <Form.Item
              label="Material Cost"
              name="standardMaterialCost"
            >
              <InputNumber
                formatter={value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                parser={value => value!.replace(/\$\s?|(,*)/g, '')}
                placeholder="Type dollar amount"
                style={{width: "100%"}}
              />
            </Form.Item>
          </Col>
          <Col>
            <Form.Item label="Labor Cost" >
              {Utils.formatMoney( laborCost )}
              <Tooltip title={"Update Operations to change this value."}>
                <InfoCircleTwoTone style={{marginLeft: ".4rem"}} />
              </Tooltip>
            </Form.Item>
          </Col>

        </Row>
      </Form>

      <Title level={4}>History</Title>
      <AssemblyCostHistory assembly={assembly} latestPricing={latestPricing} onCostsUpdated={() => assemblyAsync.mutate()}/>
    </>};

  const DetailsTabPane = () => <>
    <Form
      form={form}
      name="details"
      initialValues={initialValues}
      labelCol={{span: 4}}
      labelAlign="right"
      disabled={!!getDisabledUpdateMsg()}
    >
      <Title level={4}>Assembly Details</Title>

      <Form.Item
        label="Id"
        name="id"
        hidden={true}
      >
        <Input  />
      </Form.Item>

      <Form.Item
        label="Name"
        name="label"
      >
        <Input />
      </Form.Item>

      <Form.Item
        label="Dealer Exclusive"
        name="dealerExclusives"
      >
        <DealerMultipleSelector />
      </Form.Item>

      <Form.Item
          label="Customer Exclusive"
          name="customerExclusives"
      >
        <QuoteEndCustomerSelector />
      </Form.Item>

      <Form.Item
          label="Customer Tag Exclusive"
          name="customerTagExclusives"
      >
        <CustomerTagSelector data-testid="customerTagExclusives" />
      </Form.Item>

      <Form.Item
          label="Tags"
          name="tags"
      >
        <Select mode="tags"
                options={Object.values(AssemblyTags).map(t => ({layout: t, value:t}))}
        />
      </Form.Item>

      <Form.Item
          shouldUpdate
          name="replacementAssemblyId"
          label="Replacement Assembly"
      >
        <Select
            allowClear
            showSearch
            optionFilterProp="label"
            loading={replacementAssemblyLst.isLoading}
            options={replacementAssemblyLst.data?.content?.map(a => ({value:a.id, label: Utils.getAssemblyInfoDisplayLabel(a) }))} />
      </Form.Item>

      <Form.Item
          label="Models"
          name="modelIds"
      >
        <ModelMultipleSelector />
      </Form.Item>

          <Form.Item
              label="Notes"
              name="notes"
          >
            <Input.TextArea rows={4} style={{fontFamily: "monospace"}}/>
          </Form.Item>
          <Form.Item
              label={"Preview"}
              dependencies={["notes"]}>
            {(f) => <div className={"markdown-body"}><Markdown remarkPlugins={[remarkGfm]}>{form.getFieldValue("notes")}</Markdown></div> }
          </Form.Item>

    </Form>
  </>

  const MetadataTabPane = () => <>
    <Form
      form={form}
      name="metadata"
      initialValues={initialValues}
      labelCol={{span: 4}}
      labelAlign="right"
      disabled={!!getDisabledUpdateMsg()}
    >
    <MetadataFieldList />
    </Form>
  </>

  const getGroupFromMapping = (idx: number) => {
    return operationMapping[form.getFieldValue("operations")[idx].operationId];
  }

  const existDefaultType = (operationId: string | undefined) => {
    return operationId && operationId in operationMapping && ((operationMapping[operationId] ?? OPERATION_TYPE.BOTH) !== OPERATION_TYPE.BOTH);
  }

  const onSetOperation = (idx: number) => {
    // reset group when operation is changed
    const currentOperations = [...form.getFieldValue("operations")];
    const newGroup = !!idx && existDefaultType(form.getFieldValue("operations")[idx]?.operationId) ? getGroupFromMapping(idx) : undefined;

    currentOperations[idx].group = newGroup;
    form.setFieldValue("operations", currentOperations);

    setGroupOptions({}); // force selection option to re-render
  }

  const assignDefaultGroup = (idx: number) => {
    const operationId = form.getFieldValue("operations")?.[idx]?.operationId || "";
    return existDefaultType(operationId);
  }

  const OperationsTabPane = () => <>
    <Form
      form={form}
      name="operations"
      initialValues={initialValues}
      disabled={!!getDisabledUpdateMsg()}
    >
      <Form.List name="operations" >
        {(fields, { add, remove }) => (
          <>
            <Title level={4}>
              Operations
              <Button onClick={(_e) => add()} icon={<PlusOutlined/>} style={{backgroundColor: "#1677ff", color: "white", marginLeft: ".5rem"}} shape="circle" size="small"/>
            </Title>
            {fields.map((ao, idx) => (
              <div key={idx}>
                <Form.Item
                  name={[ao.name, "id"]}
                  noStyle
                  hidden
                >
                  <Input hidden />
                </Form.Item>
                <Space>
                  <Form.Item
                    name={[ao.name, "operationId"]}
                    label="Operation"
                    rules={[
                      {
                        required: true,
                        message: "Operation is required",
                      },
                    ]}
                  >
                    <Select
                      showSearch
                      style={{ width: 300 }}
                      onChange={() => onSetOperation(idx)}
                    >
                      {operations
                        ?.filter( o => isCurrentOrSelected(initialValues?.operations?.[ao.name], o) )
                        .map((o, idx) =>
                          <Select.Option value={o.operationId} key={o.operationId + "-" + idx}>
                            {!o.current 
                              ?  <span style={{color: "red"}}>{o.operationId}</span>
                              :  <>{o.operationId}</>
                            }
                          </Select.Option>
                            )}
                    </Select>
                  </Form.Item>
                  &nbsp;
                  <Form.Item
                    name={[ao.name, "group"]}
                    label="Group"
                    rules={[
                      {
                        required: true,
                        message: "Group is required",
                      },
                    ]}
                  >
                    <Select
                      showSearch
                      style={{ width: 150 }}
                      optionFilterProp="children"
                      options={
                        assignDefaultGroup(idx) ? 
                        [{label: getGroupFromMapping(idx), 
                          key: getGroupFromMapping(idx),
                          value: getGroupFromMapping(idx),
                        }]
                        : 
                        [
                        {label:"CAB", value:"CAB", key: "CAB" },
                        {label:"CHASSIS", value:"CHASSIS", key: "CHASSIS" },
                        ]
                      }
                    />
                  </Form.Item>
                  &nbsp;
                  <Form.Item
                    name={[ao.name, "hours"]}
                    label="Hours"
                    rules={[
                      {
                        required: true,
                        message: "Hours are required",
                      },
                    ]}
                  >
                    <Input style={{ width: 100 }} />
                  </Form.Item>
                  <DeleteOutlined onClick={() => remove(ao.name)} style={{paddingLeft: "1rem", marginBottom: "24px", color: "red"}} />
                </Space>
              </div>
            ))}
          </>)}
      </Form.List>
    </Form>
  </>

  const DependenciesTabPane = () => <>
    <Title level={4}>Dependencies</Title>
    <Form
      form={form}
      name="dependencies"
      initialValues={initialValues}
      disabled={!!getDisabledUpdateMsg()}
    >
      <Form.Item
        label="Dependencies"
        name="assemblyDependencies"
      >
        <AssemblySelector />
      </Form.Item>
      <Title level={4}>
        Dependencies by Category
        <Button onClick={onAddNewDependency} icon={<PlusOutlined/>} style={{backgroundColor: "#1677ff", color: "white", marginLeft: ".5rem"}} shape="circle" size="small"/>
      </Title>
      {categoryLst.data && dependencyRules?.map((dr) => (
        <div key={dr.uuid}>
          <DependencyCriteria
            initialState={dr}
            onUpdateCriteria={(cri:DependencyRule[] ) => {
              onUpdateCriteria(cri, dr.uuid);
            }}
            categories={categoryLst.data}
          />
        </div>
      ))}
    </Form>
  </>

  const getChangeType = (ah: AssemblyHistory): string => {
    switch (ah.changeType) {
      case AssemblyChangeType.CREATE_ASSEMBLY: return "Assembly Creation";
      case AssemblyChangeType.IMPORT_ASSEMBLY: return "Import Assembly";
      case AssemblyChangeType.UPDATE_ASSEMBLY: return "Assembly Update";
      case AssemblyChangeType.UPLOAD_ASSEMBLY_IMAGE: return "Upload Assembly Image";
    }
    return ah.changeType;
  }

  const getApprovedBy = (ah: AssemblyHistory): string => {
    return `${ah.createdBy} at ${dayjs(ah.createdAt).format("M/D/YY, h:mm a")}`;
  }

  const getChangeTitle = (change: AssemblyHistory) => {
    return (
      <div style={{display: "flex", justifyContent: "center", alignItems: "center", position: "relative"}}>
        <div style={{position: "absolute", right: 0}}>{getApprovedBy(change)}</div>
        <div>{getChangeType(change)}</div>
      </div>
    );
  }

  const HistoryTabPane = () => <>
      <style>
        {`
          .history-collapse {
            border: 2px solid #1890ff;
            background-color: white;
          }
          .history-collapse .ant-collapse-header .ant-collapse-arrow svg {
            color: darkgrey;
            fill: #1677ff;
          }
          .history-collapse .ant-collapse-header-text {
            color: #1677ff;
          }
        `}
      </style>
    <Title level={4}>History</Title>
    {assemblyHistory?.map((ah, idx) => 
       <div key={"div-" + idx}>
        <Collapse style={{marginBottom: ".6rem"}} key={`history-panel-${idx}`} defaultActiveKey={"change-" + ah.id + "-panel"} className="history-collapse" bordered={false}>
            <Collapse.Panel header={getChangeTitle(ah)} key={"change-" + ah.id + "-panel"}>
              {RenderHistory(ah, models.data?.content)}
            </Collapse.Panel>
        </Collapse>
     </div>
    )}
  </>

  const getDisabledMovePendingMsg = () : string | undefined => {
    return !canWrite ? "You need permission to import assembly."
    : ((quoteCnt || 1) > 0 ) ? "Cannot move to pending while assembly is assigned to a quote."
    : !isImported ? "This assembly has not been imported."
    : isLoadingFail ? "Data failed to load.  Please refresh."
    : undefined;
  }

  const getDisabledUpdateMsg = () : string | undefined => {
    return !canWrite ? "You need permission to import assembly."
    : !isImported ? "This assembly has not been imported."
    : isLoadingFail ? "Data failed to load.  Please refresh."
    : undefined;
  }

  const onTabClick = (key: string) => {
    if(key === "history") {
      loadHistory(params.id);
    }
  }

  return <div className="site-layout-background">
    <Space direction={"vertical"} >
      <div>
        <Title level={2}>View Assembly</Title>
      </div>
      <div>
        <Space>
          <Dropdown
              trigger={["click"]}
              menu={{items:[
                  {
                    key: "movePending",
                    label:
                        <BMButton
                            type="text"
                            onClick={handleMoveToPending}
                            loading={assemblyAsync.isLoading || assemblyStatistics.isLoading}
                            disabled={!!getDisabledMovePendingMsg()}
                            onDisabledClick={() => Utils.warning(getDisabledMovePendingMsg())}
                        >
                          Move Pending
                        </BMButton>
                  },
                  {
                    key: "copy",
                    label: <NewAssemblyModal type={"text"} refAsm={assembly}/>
                  },
                ]}}
          >
            {/* this div is to avoid a warning with strict mode */}
            <div>
              <Button type="primary" icon={<MoreOutlined/>} >Options</Button>
            </div>
          </Dropdown>

          <UpdateModal
              assembly={assembly}
              loading={assemblyAsync.isLoading}
              disabled={!!getDisabledUpdateMsg()}
              onDisabledClick={() => Utils.warning(getDisabledUpdateMsg())}
              onSubmit={(reason) => onSubmitForm(reason)}
              form={form}
              setValidationAlert={setValidationAlert}
          />


        </Space>

      </div>
    </Space>
      <div className={styles.assemblyView}>
      <Spin className="assemblyLoading" spinning={isLoading} >
          <Form.Provider >
            <Row>
              <Col span={24}>
                <Form
                  form={form}
                  name="assembly"
                  initialValues={initialValues}
                  labelCol={{span: 3}}
                  labelAlign="right"
                >
                  <Row gutter={15} style={{marginTop: "1rem"}}>
                    <Col >
                      <UploadImage
                          assemblyId={assembly?.id}
                          thumbnailImageUrl={assembly?.thumbnailImageUrl}
                          onChange={() => assemblyAsync.mutate()}
                      />
                    </Col>
                    <Col>
                      <Descriptions
                          size="small"
                          column={1}
                          className={"bm-descriptions"}
                          labelStyle={{width: "6rem", textAlign: "right", display: "block" }}
                          items={[
                            {
                              key: 'bom',
                              label: 'BOM',
                              children: <Paragraph copyable={{text: assembly?.bom}}>{assembly?.bom}</Paragraph>

                            },
                            {
                              key: 'bomDescription',
                              label: 'Description',
                              children: assembly?.bomDescription
                            },
                            {
                              key: 'category',
                              label: 'Category',
                              children:
                                  <Form.Item name="categoryId" style={{width: "25rem", margin: 0}}>
                                    <BMReadOnly readOnly={!configurator.isAdmin()}
                                                renderValue={() => <Link style={{fontWeight: 400 }} to={"/categories/" + assembly?.category.id}>{assembly?.category.name}</Link> }>
                                      <CategorySelector allowClear={false} />
                                    </BMReadOnly>
                                  </Form.Item>
                            },
                            {
                              key: 'quotes',
                              label: <>
                                <span>Quotes</span>
                                <Tooltip title="This is the number of quotes currently using this assembly."><QuestionCircleOutlined style={{marginLeft: "3px", color: "darkgrey"}}/></Tooltip>
                              </>,
                              children:
                                  <Button type="text"
                                          onClick={() => gotoQuoteList(assembly?.id)}
                                          loading={assemblyStatistics.isLoading}
                                          style={{padding: 0}}
                                  >
                                    {quoteCnt}
                                  </Button>
                            },
                          ]}
                      >
                      </Descriptions>
                    </Col>
                  </Row>
                </Form>

                <Tabs defaultActiveKey={tabKeyParam || undefined}
                  onChange={setTabKey}
                  onTabClick={(key) => onTabClick(key)}
                  items={[{
                    key:"1",
                    label:"Details",
                    children: <DetailsTabPane/>,
                    forceRender: true,
                  },
                  {
                    key:"2",
                    label:"Metadata",
                    children: <MetadataTabPane/>,
                    forceRender: true,
                  },
                  {
                    key:"3",
                    label:"Pricing",
                    children: <CostHistoryTabPane/>,
                    forceRender: true,
                  },
                  {
                    key:"4",
                    label:
                    <> 
                      <span>Operations</span>
                      {!!validationAlert?.length && <Tooltip title={validationAlert.map(a => <div key={a + "-alert"}>{a}</div>)}>
                        <WarningFilled style={{marginLeft: ".5rem", fontSize: "20px",  color: "orange" }} size={5}/>
                      </Tooltip>}
                    </>,
                    children: <OperationsTabPane/>,
                    forceRender: true,
                  },
                  {
                    key:"5",
                    label:"Dependencies",
                    children: <DependenciesTabPane/>,
                    forceRender: true,
                  },
                  {
                    key:"documents",
                    label:"Documents",
                    children: <DocumentsTabPane/>,
                    forceRender: true,
                  },
                  {
                    key:"history",
                    label:"History",
                    children: <HistoryTabPane/>,
                    forceRender: true,
                  }
                ]}
                />

              </Col>
            </Row>
          </Form.Provider>

      </Spin>
    </div>
    </div>
};

export default ViewAssembly;


const UpdateModal = (props: {
  assembly: Assembly | undefined,
  loading: boolean,
  onDisabledClick: () => void,
  disabled: boolean,
  onSubmit: (val: string) => void,
  form: FormInstance,
  setValidationAlert: (val: string[]) => void
}) => {

  const [reasonForm] = Form.useForm();
  const {loading, disabled, onDisabledClick, onSubmit, form, setValidationAlert} = props;
  const [showReasonModal, setShowReasonModal] = useState(false);
  const reason = Form.useWatch<string>('reason', reasonForm);

  const onCancel = () => {
    setShowReasonModal(false);
    reasonForm.resetFields();
  }

  const validateForm = async () : Promise<ValidateFields | undefined> => {

    try {
      const values = await form.validateFields();
      setShowReasonModal(true);

      return values;
    }
    catch(e:any) {
      const validationErrors = e as ValidateErrorEntity;
      notification.error({message: "Please fix validation errors." });
      setValidationAlert(validationErrors?.errorFields?.map(f => f.errors.join(" ")));
    }

    return;
  }

  return (
    <>
      <BMButton
        type="primary"
        onClick={validateForm}
        loading={loading}
        disabled={disabled}
        onDisabledClick={onDisabledClick}
      >
        Save
      </BMButton>
      <Modal
        open={showReasonModal}
        okText={"Update"}
        closable={true}
        width={'50rem'}
        title="Reason for upate"
        onCancel={onCancel}
        footer={[
          <Button key="submit" type="primary"
            disabled={!reason}
            onClick={() => {onSubmit(reason); onCancel()}} >
            Update
          </Button>,
        ]}
      >
        <Form
          form={reasonForm}
        >
          <Form.Item
            name="reason"
            label="Reason"
            rules={[{ required: true, message: "Reason is required" }]}
          >
            <Input placeholder={'Please enter the reason here.'} />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
}

const RenderHistory = (ah: AssemblyHistory, modelList: BaseModel[] | undefined) => {
  
  
  interface OperationChange {
    addedOperations: AssemblyOperation[],
    existingOperations: AssemblyOperation[],
    removedOperations: AssemblyOperation[],
    updatedOperations: AssemblyOperation[],
  }

  let operationChange: OperationChange = { 
    addedOperations: [],
    existingOperations: [],
    removedOperations: [],
    updatedOperations: []
  };

  const dealers = useDealers();

  const customers = useCustomers();

  const change = ah.assemblyChange;

  const columns: ColumnType<{ item: string, before: any, after: any; }>[] = [
    {
      dataIndex: "item",
      title: "Item",
      width: "20%"
    },
    {

      title: "Before",
      width: "40%",
      render: (change: {item: string, before: any, after: any}) => {
        if (change.item === "Image" && change.before !== "NA") {
          return <img src={change.before} alt="NA" style={{ width: 100, height: 100 }} />
        }
        return <span>{change.before}</span>
      }
    },
    {

      title: "After",
      width: "40%",
      render: (change: {item: string, before: any, after: any}) => {
        if (change.item === "Image" && change.after !== "NA") {
          return <img src={change.after} alt="NA" style={{ width: 100, height: 100 }} />
        }
        return <span>{change.after}</span>
      }
    },
  ];

  let data: {item: string, before: any, after: any}[] = [];

  if (change) {

    Object.keys(change)?.forEach(key => {
      if (String(key) === "label" || String(key) === "notes" || String(key) === "nonOption" || String(key) === "obsoleted"
      || String(key) === "standardMaterialCost" || String(key) === "userRequireInput" || String(key) === "replacementAssembly" || String(key) === "image"
      || String(key) === "customerTagExclusives") {
        const item = change[key].item as string;
        let before = change[key].before == undefined ? "" : [].concat(change[key].before).join(", ");
        let after = change[key].after == undefined ? "" : [].concat(change[key].after).join(", ");
        if (String(key) === "standardMaterialCost") {
          before = change[key].before == undefined ? "" : Utils.formatMoney(change[key].before);
          after = change[key].after == undefined ? "" : Utils.formatMoney(change[key].after);
        }
        data.push({item, before: String(before) || "NA", after: String(after) || "NA"});
      }
      else if (String(key) === "dealerExclusives") {
        const item = change[key].item as string;
        const before = change[key].before == undefined ? "" : [].concat(change[key].before).map(dealerId => dealers.data?.content.find(d => d.id === dealerId)?.name).join(", ");
        const after = change[key].after == undefined ? "" : [].concat(change[key].after).map(dealerId => dealers.data?.content.find(d => d.id === dealerId)?.name).join(", ");
        data.push({item, before: String(before) || "NA", after: String(after) || "NA"});
      }
      else if (String(key) === "customerExclusives") {
        const item = change[key].item as string;
        const before = change[key].before == undefined ? "" : [].concat(change[key].before).map(customerId => customers.data?.find(d => d.id === customerId)?.name).join(", ");
        const after = change[key].after == undefined ? "" : [].concat(change[key].after).map(customerId => customers.data?.find(d => d.id === customerId)?.name).join(", ");
        data.push({item, before: String(before) || "NA", after: String(after) || "NA"});
      }
      else if (String(key) === "operations") {
        operationChange = change[key];
      }
      else if (String(key) === "modelChange") {
        const item = change[key].item as string;
        const before = change[key].before == undefined ? "" : [].concat(change[key].before).map(modelId => modelList?.find(d => d.id === modelId)?.name).sort().join(", ");
        const after = change[key].after == undefined ? "" : [].concat(change[key].after).map(modelId => modelList?.find(d => d.id === modelId)?.name).sort().join(", ");
        data.push({item, before: String(before) || "NA", after: String(after) || "NA"});
      }
      else if (String(key) === "metadata") {
        const updateMetadata = change[key].updatedMetadata.sort((a: AssemblyMetadata, b: AssemblyMetadata) => a.categoryMetadata.id - b.categoryMetadata.id);
        const existingMetadata = change[key].existingMetadata.sort((a: AssemblyMetadata, b: AssemblyMetadata) => a.categoryMetadata.id - b.categoryMetadata.id);
  
        (updateMetadata || []).forEach((u: AssemblyMetadata, uid: number) => {
          let item = u.categoryMetadata.name || "";
          let after = updateMetadata?.[uid] == undefined ? "" : updateMetadata?.[uid]; 
          let before = existingMetadata?.[uid] == undefined ? "" : existingMetadata?.[uid]; 
          if (Utils.getMetadataValue(before) || Utils.getMetadataValue(after)) {
            data.push({item, before: Utils.getMetadataValue(before) || "NA", after: Utils.getMetadataValue(after) || "NA"});
          }
        });
  
        (change[key].addedMetadata || []).forEach((u: AssemblyMetadata, uid: number) => {
          let item = u.categoryMetadata.name || "";
          let after = change[key].addedMetadata?.[uid] == undefined ? "" : change[key].addedMetadata?.[uid]; 
          if (Utils.getMetadataValue(after)) {
            data.push({item, before: "NA", after: Utils.getMetadataValue(after)});
          }
        });
  
        return data;
      }
  
    });
  }



  return (
    <>
      <style>
        {`
          .head-row-white .ant-table-thead > tr > th {
            background-color: white;
          }
        `}
      </style>

      {ah.initial && <div key={`${ah.id}-initial-record}`}>Initial Update Record</div>}

      {!ah.initial && <span key={`history reason - ${ah.id}`}><strong>Reason: </strong>{ah.reason}</span>}

      {!!data.length && <Table
        columns={columns}
        dataSource={data}
        pagination={false}
        style={{marginTop: "1rem", marginRight: "1rem"}}
        className="head-row-white"
        rowKey={"item"}
      />}
      {
      !!operationChange?.addedOperations.length && 
      <div key={`${ah.id}-operation-change-added`} style={{marginTop: ".5rem"}}>
        <div key={`${ah.id}-operation-change-added-title`}>
          Added Operations:
        </div>
        {<ul>
        {operationChange?.addedOperations?.map((op: AssemblyOperation, idx: number) => <li key={`${ah.id}-operation-change-added-${idx}`}>
          {`Operation: ${op.operationId} Group: ${op.group}  Hours: ${op.hours}`}
        </li>)}
        </ul>}
      </div>
      }

      {!!operationChange?.removedOperations.length && 
      <div key={`${ah.id}-operation-change-removed`} style={{marginTop: ".5rem"}}>
        <div key={`${ah.id}-operation-change-removed-title`}>
          Removed Operations:
        </div>
        {<ul>
          {operationChange?.removedOperations?.map((op: AssemblyOperation, idx: number) => 
            <li key={`${ah.id}-operation-change-removed-${idx}`}>{`Operation: ${op.operationId} Group: ${op.group}  Hours: ${op.hours}`}</li>
          )}
        </ul>}
      </div>}

      {!!operationChange?.updatedOperations.length && 
      <div key={`${ah.id}-operation-change-update`} style={{marginTop: ".5rem"}}>
        <div key={`${ah.id}-operation-change-update-title`}>
          Updated Operations:
        </div>
        {<ul>
        {operationChange?.existingOperations?.map((op: AssemblyOperation, idx: number) => 
        <li key={`${ah.id}-operation-change-update-${idx}`}>
          <span key={`history-operation-update-from-${ah.id}`}>{`Operation: ${op.operationId} Group: ${op.group}  Hours: ${op.hours}`}</span>
          {"    ->    "}
          {operationChange.updatedOperations.filter(eop => eop.id === op.id).map(eop => <span key={`history-operation-update-to-${ah.id}`}>
            {` Operation: ${eop.operationId} Group: ${eop.group}  Hours: ${eop.hours}`}
            </span>)}
        </li>
        )}
        </ul>
        }
      </div>}
    </>)
}


